import { createAction, props } from '@ngrx/store';
import { BrandingConfiguration } from './models/BrandingConfiguration';

export const loadAppConfiguration = createAction('[App Configuration] Load');

export const loadAppConfigurationSuccess = createAction(
    '[App Configuration] Load Success',
    props<{ configuration: any }>()
);

export const loadAppConfigurationFailure = createAction(
    '[App Configuration] Load Failure',
    props<{ error: any }>()
);

export const setLoadingState = createAction(
    '[App Configuration] Set Loading State',
    props<{ isLoading: boolean }>()
);

export const loadBrandingConfiguration = createAction(
    '[Branding Configuration] Load Success'
);

export const loadBrandingConfigurationSuccess = createAction(
    '[Branding Configuration] Load Success',
    props<{ brandingConfiguration: BrandingConfiguration }>()
);

export const loadBrandingConfigurationFailure = createAction(
    '[Branding Configuration] Load Failure',
    props<{ error: any }>()
);